export default "__VITE_ASSET__j59R8Kzi__"